/**
 * Lazy MorningReport pages, so the slot board and case audio stay out of the
 * chunks of roles that never open them.
 */
import React from "react";
import Loading from "components/Loading";

const loadWorkspace = () => import("./pages/MorningReportWorkspacePage");
const ListPage = React.lazy(() => import("./pages/MorningReportListPage"));
const WorkspacePage = React.lazy(loadWorkspace);
const CaseMakerPage = React.lazy(() => import("./pages/MorningReportCaseMakerPage"));
const GuestStartPage = React.lazy(() => import("./pages/MorningReportGuestStartPage"));

/** The case list loads the workspace chunk early, so opening a case doesn't flash a spinner. */
export const preloadWorkspace = () => {
  loadWorkspace().catch(() => {});
};

export const MorningReportList = () => (
  <React.Suspense fallback={<Loading page />}>
    <ListPage />
  </React.Suspense>
);

export const MorningReportWorkspace = () => (
  <React.Suspense fallback={<Loading page />}>
    <WorkspacePage />
  </React.Suspense>
);

export const MorningReportGuestStart = () => (
  <React.Suspense fallback={<Loading page />}>
    <GuestStartPage />
  </React.Suspense>
);

export const MorningReportCaseMaker = () => (
  <React.Suspense fallback={<Loading page />}>
    <CaseMakerPage />
  </React.Suspense>
);
